import { useState } from "react";
import { CalendarX, Plus, X } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";

const iso = (d) => d.toLocaleDateString("en-CA");
const nice = (s) => new Date(`${s}T12:00:00`).toLocaleDateString("en-CA", { weekday: "short", month: "short", day: "numeric", year: "numeric" });

export const ClosuresEditor = ({ value, onChange }) => {
  const [date, setDate] = useState("");
  const [note, setNote] = useState("");
  const today = iso(new Date());
  const max = iso(new Date(Date.now() + 365 * 864e5));
  const add = () => {
    if (!date || date < today || value.some((c) => c.date === date) || value.length >= 30) return;
    onChange([...value, { date, note: note.trim() }].sort((a, b) => a.date.localeCompare(b.date)));
    setDate(""); setNote("");
  };
  return (
    <div data-testid="closures-editor">
      <Label className="flex items-center gap-1.5"><CalendarX size={14} className="text-[#F5551E]" /> Special closures &amp; holidays <span className="text-slate-400 font-normal">({value.length}/30)</span></Label>
      <p className="text-xs text-slate-500 mt-0.5">On these days your badge shows “Closed today”, whatever your regular hours.</p>
      <div className="flex flex-wrap gap-2 mt-2">
        <Input type="date" value={date} min={today} max={max} onChange={(e) => setDate(e.target.value)} className="h-10 rounded-lg w-44" data-testid="closure-date" />
        <Input value={note} onChange={(e) => setNote(e.target.value)} maxLength={60} placeholder="Reason (optional), e.g. Canada Day" className="h-10 rounded-lg flex-1 min-w-[180px]" data-testid="closure-note"
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }} />
        <Button type="button" onClick={add} disabled={!date || value.length >= 30} className="h-10 rounded-lg bg-[#12234A] hover:bg-[#0E1B38] text-white gap-1" data-testid="closure-add"><Plus size={15} /> Add</Button>
      </div>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {value.map((c) => (
            <span key={c.date} className="inline-flex items-center gap-1.5 bg-red-50 text-red-700 border border-red-200 text-xs font-semibold px-3 py-1.5 rounded-full" data-testid={`closure-chip-${c.date}`}>
              {nice(c.date)}{c.note ? ` · ${c.note}` : ""}
              <button type="button" onClick={() => onChange(value.filter((x) => x.date !== c.date))} aria-label="Remove closure" className="hover:text-red-900" data-testid={`closure-remove-${c.date}`}><X size={13} /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
